// extracted by mini-css-extract-plugin
export default {"icon":"ChatGroup-module-b9e7255616bbbb61df5d"};